import BaseStore from './BaseStore';
import rp from 'request-promise';
import config from '../config';
// import { notification } from 'antd'
import { getToken } from '../components/Token';
import { getTenantHeaders } from '../components/TenantHeaders';
import { clearLocalStorage } from '../utils/common';
import _ from 'lodash';

const defaultData = {
  error: false,
  password: {
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  },
};

export class UserStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      loading: false,
      users: [],
      offset: 0,
      page: 0,
      limit: 15,
      search: null,
      sort: null,
      order: null,
      tenantIds: null,
      userDetail: {},
      data: _.cloneDeep(defaultData),
      action: null,
      usersPatient: [],
    });
  }

  setAction(task, data) {
    this[task] = data;
  }

  resetData() {
    this.offset = 0;
    this.limit = 15;
    this.search = null;
    this.sort = null;
    this.order = null;
    this.tenantIds = null;
    this.users = [];
  }

  changeData(key, value) {
    this.data.password[key] = value;
    this.data.error = false;
  }

  setError() {
    this.data.error = true;
  }

  async setData(task, data, getUser = true) {
    this[task] = data;
    if (getUser) {
      this.getUser(this.offset, this.limit, this.search, this.sort, this.order, this.tenantIds);
    }
  }

  async getUser(offset = 0, limit = 15, search = null, sort = null, order = null, tenantIds = null) {
    this.loading = true;
    let queryOption = {};
    queryOption.offset = offset;
    queryOption.limit = limit;
    if (tenantIds && tenantIds.length > 0) {
      queryOption.tenantIds = JSON.stringify(tenantIds);
    }
    if (search) {
      queryOption.search = search;
    }
    if (sort) {
      queryOption.sort = sort;
    }
    if (order) {
      queryOption.order = order;
    }
    try {
      let url = `${config.api.url}/${config.api.version}/users`;
      const res = await rp
        .get({
          uri: url,
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const users = res.body || {};
        return (this.users = users);
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getUserById(id) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/users/${id}`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const users = res.body || {};
        return (this.userDetail = users);
      }
    } catch (err) {
      // if (err.statusCode === 401) {
      //     setTimeout(() => {
      //       removeToken('id_token')
      //       window.location.href = '/login'
      //     }, 1000)
      //   }
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async createUser(data) {
    this.loading = true;
    try {
      const detail = {
        userName: data.username,
        password: data.password,
        roleId: data.roleId,
        email: data.email,
        tel: data.tel,
        firstName: data.firstName,
        lastName: data.lastName,
        tenantPermission: localStorage.getItem('tenant_permission')
        // tenantId: data.tenantId
        // chanel: 'web'
      };
      let url = `${config.api.url}/${config.api.version}/users`;
      const res = await rp
        .post(url, {
          body: detail,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      console.log('error', err);
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async updateUser(data) {
    this.loading = true;
    try {
      const detail = {
        userName: data.username,
        userRole: '',
        roleId: data.roleId,
        email: data.email,
        tel: data.tel,
        chanel: 'web',
        tenantPermission: data.tenantPermission ? JSON.stringify(data.tenantPermission) : null,
        locationPermission: data.locationPermission ? JSON.stringify(data.locationPermission) : null,
        groupPermission: data.groupPermission ? JSON.stringify(data.groupPermission) : null,
        subgroupPermission: data.subgroupPermission ? JSON.stringify(data.subgroupPermission) : null,
        firstName: data.firstName,
        lastName: data.lastName
      };

      let url = `${config.api.url}/${config.api.version}/users/${data.id}`;
      const res = await rp
        .put(url, {
          body: detail,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async deleteUser(id) {
    this.loading = true;
    try {
      const res = await rp
        .delete(`${config.api.url}/${config.api.version}/users/softdelete/${id}`, {
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          qs: {
            accessToken: getToken('access_token'),
          },
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async assignRole(roleId, userId) {
    this.loading = true;
    try {
      const detail = {
        id: userId,
        roleId: roleId === ' ' ? null : roleId,
      };
      let url = `${config.api.url}/${config.api.version}/users/role/assign`;
      const res = await rp
        .post(url, {
          body: detail,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async updateSubgroupPermission(subgroupIds) {
    this.loading = true;
    try {
      if (subgroupIds.length > 0) {
        let url = `${config.api.url}/${config.api.version}/users/permission/subgroup`;
        const res = await rp
          .put(url, {
            body: { subgroupIds },
            authorization: true,
            resolveWithFullResponse: true,
            json: true,
            headers: {
              ...getTenantHeaders(),
            },
          })
          .auth(null, null, true, getToken('id_token'));
        if (res && res.statusCode === 200) {
          return res;
        }
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async updateGroupPermission(groupIds) {
    this.loading = true;
    try {
      if (groupIds.length > 0) {
        let url = `${config.api.url}/${config.api.version}/users/permission/group`;
        const res = await rp
          .put(url, {
            body: { groupIds },
            authorization: true,
            resolveWithFullResponse: true,
            json: true,
            headers: {
              ...getTenantHeaders(),
            },
          })
          .auth(null, null, true, getToken('id_token'));
        if (res && res.statusCode === 200) {
          return res;
        }
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async updateLocationPermission(locationIds) {
    this.loading = true;
    try {
      if (locationIds.length > 0) {
        let url = `${config.api.url}/${config.api.version}/users/permission/location`;
        const res = await rp
          .put(url, {
            body: { locationIds },
            authorization: true,
            resolveWithFullResponse: true,
            json: true,
            headers: {
              ...getTenantHeaders(),
            },
          })
          .auth(null, null, true, getToken('id_token'));
        if (res && res.statusCode === 200) {
          return res;
        }
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async updatePassword(data, userId) {
    this.loading = true;
    try {
      const detail = {
        currentPassword: data.password.currentPassword,
        newPassword: data.password.newPassword,
        accessToken: getToken('access_token'),
      };

      let url = `${config.api.url_auth}/${config.api.version}/auth/changepassword`;
      const res = await rp
        .put(url, {
          body: detail,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        const body = {
          userName: localStorage.getItem('user'),
          type: 'changePassword',
        };
        await rp
          .post(`${config.api.url}/${config.api.version}/fetch`, {
            body: body,
            json: true,
            authorization: true,
            resolveWithFullResponse: true,
            headers: {
              ...getTenantHeaders(),
            },
          })
          .auth(null, null, true, res.body.IdToken);
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getUserPatient(patientId) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/users/patient/${patientId}`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        const users = res.body || [];
        this.usersPatient = users;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async createUserPatient(data) {
    this.loading = true;
    try {
      const patientId = data.patientId;
      const userPatient = {
        userName: data.username,
        password: data.password,
        chanel: 'web',
        tenantId: data.tenantId,
      };
      let url = `${config.api.url}/${config.api.version}/users/patient/${patientId}`;
      const res = await rp
        .post(url, {
          body: userPatient,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async deleteUserPatient(userId) {
    this.loading = true;
    try {
      const res = await rp
        .delete(`${config.api.url}/${config.api.version}/users/forcedelete/role/patient/${userId}`, {
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          qs: {
            accessToken: getToken('access_token'),
          },
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async resetPassword(data, userId) {
    this.loading = true;
    try {
      const detail = {
        username: data.username,
        newPassword: data.password,
      };

      let url = `${config.api.url_auth}/${config.api.version}/users/${userId}/change/password`;
      const res = await rp
        .put(url, {
          body: detail,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        const body = {
          userName: localStorage.getItem('user'),
          type: 'changePassword',
        };

        await rp
          .post(`${config.api.url}/${config.api.version}/fetch`, {
            body: body,
            json: true,
            authorization: true,
            resolveWithFullResponse: true,
            headers: {
              ...getTenantHeaders(),
            },
          })
          .auth(null, null, true, getToken('id_token'));
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async forgotPassword(identifier) {
    this.loading = true;
    try {
      const detail = {
        identifier
      };

      let url = `${config.api.url_auth}/${config.api.version}/auth/forgotpassword`;
      const res = await rp
        .post(url, {
          body: detail,
          // authorization: true,
          resolveWithFullResponse: true,
          json: true,
          // headers: {
          //   ...getTenantHeaders(),
          // },
        })
      // .auth(null, null, true, getToken('id_token'));

      if (res && res.statusCode === 200) {

        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async resetPasswordByToken(data) {
    this.loading = true;
    try {
      const detail = {
        ...data
      };

      let url = `${config.api.url_auth}/${config.api.version}/auth/resetpassword/token`;
      const res = await rp
        .put(url, {
          body: detail,
          // authorization: true,
          resolveWithFullResponse: true,
          json: true,
          // headers: {
          //   ...getTenantHeaders(),
          // },
        })
      // .auth(null, null, true, getToken('id_token'));

      if (res && res.statusCode === 200) {
        // const body = {
        //   userName: localStorage.getItem('user'),
        //   type: 'changePassword',
        // };

        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async resetPasswordByAdmin(userId, password) {
    this.loading = true;
    try {
      const detail = {
        password: password,
      };

      let url = `${config.api.url_auth}/${config.api.version}/users/${userId}/reset/password/admin`;
      const res = await rp
        .put(url, {
          body: detail,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {

        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

}

export default new UserStore();
